import React, { useEffect } from "react";
import { withRouter, Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import { TICKET_CONFIG_LIST_QUERY, TICKET_CONFIG_WRITE_QUERY } from "./Queries";
import { useMutation } from "react-apollo-hooks";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import { toast } from "react-toastify";

export default withRouter(({ history, isVisible, toggleModal, isModal }) => {
  const modalRef = React.createRef();

  const [productConfigWriteMutation] = useMutation(TICKET_CONFIG_WRITE_QUERY, {
    refetchQueries: [{ query: TICKET_CONFIG_LIST_QUERY }],
    awaitRefetchQueries: true,
  });

  const { register, handleSubmit, errors } = useForm();
  const onSubmit = async (data) => {
    try {
      const {
        data: { AdminTicketConfigWrite },
      } = await productConfigWriteMutation({
        variables: {
          name: data.name,
        },
      });
      if (AdminTicketConfigWrite) {
        toast.success("설정 되었습니다.");
        toggleModal();
      }
    } catch (e) {
      console.log(e);
      toast.error("에러가 발생했습니다. 다시 시도해 주세요.");
    }
  };
  // console.log(errors);

  useEffect(() => {
    const element = modalRef.current;

    if (isModal) {
      disableBodyScroll(element);
    }

    return () => {
      enableBodyScroll(element);
    };
  });

  return (
    <>
      <Modal
        isOpen={isVisible}
        ref={modalRef}
        toggle={() => {
          toggleModal();
        }}
        size={"lg"}
      >
        <form className="margin-bottom-0" onSubmit={handleSubmit(onSubmit)}>
          <ModalHeader
            toggle={() => {
              toggleModal();
            }}
          >
            설정등록
          </ModalHeader>
          <ModalBody className=" p-0">
            <div className="form-horizontal form-bordered">
              <div className="bg-white rounded">
                <div className="form-group row">
                  <label className="col-form-label col-md-2">이름</label>
                  <div className="col-md-10">
                    <input
                      type="text"
                      name="name"
                      className="form-control"
                      placeholder="이름을 입력해주세요."
                      ref={register({
                        required: "이름을 입력해주세요.",
                      })}
                    />
                    {errors.name && <span>{errors.name.message}</span>}
                  </div>
                </div>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button type="submit" className="btn btn-white text-blue ">
              확인
            </button>
            <Link to="/ticketConfigs" className="btn btn-white text-red">
              취소
            </Link>
          </ModalFooter>
        </form>
      </Modal>
    </>
  );
});
